import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSurveys,
  selectIsLoading,
  selectLastSurvey,
  selectSurveyCount,
  selectSurveyCounts,
} from "redux-toolkit/surveys/selectors";
import {
  getSurveysAsync,
  getNextSurveysAsync,
} from "redux-toolkit/surveys/actions";

const useSurveys = () => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const surveys = useSelector(selectSurveys);
  const isLoading = useSelector(selectIsLoading);
  const last = useSelector(selectLastSurvey);
  const count = useSelector(selectSurveyCount);
  const counts = useSelector(selectSurveyCounts);

  useEffect(() => {
    dispatch(getSurveysAsync());
  }, [dispatch]);

  const getNextPage = () => {
    if (last && count > surveys.length) {
      dispatch(getNextSurveysAsync(last));
      setPage(page + 1);
    }
  };

  return {
    surveys,
    isLoading,
    hasMoreItems: count > surveys.length,
    page,
    setPage,
    getNextPage,
    totalCount: count,
    counts,
  };
};

export default useSurveys;
